import React, { ReactElement, useEffect } from 'react';
import { useEntites, useUpdateEntite } from '../../../Utils/api';
import { Badge, Button, ButtonGroup, Col, Dropdown, Row } from 'react-bootstrap';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { Colonne } from '../Utils/TypesTableSimple';
import { BiPlus } from 'react-icons/bi';
import { LinkContainer } from 'react-router-bootstrap';
import EnteteDePage from '../Utils/EnteteDePage';
import TableSimple from '../Utils/TableSimple';
import { useNavigate } from 'react-router-dom';
import { ModeleHoraire } from '../../../../../common/src/entities/modele-horaire.entity';
import { CellProps } from 'react-table';
import PopoverSimple from '../../Common/PopoverSimple';
import DynamicTableActivite from './DynamicTableActivite';
import DynamicTableProduit from './DynamicTableProduit';
import FiltreActif from '../Utils/FiltreActif';

export default function ModelesHoraire(): ReactElement {
    const navigate = useNavigate();
    const [updateModeleHoraireQuery] = useUpdateEntite(ModeleHoraire);
    const bsAlert = useAlertDialog();

    const listModelesHoraire = useEntites(ModeleHoraire);

    useEffect(() => {
        document.title = "Modèles d'horaire - Dashboard";
    }, []);

    const colonnes: Colonne<ModeleHoraire>[] = [
        {
            Header: 'Actif',
            accessor: 'actif',
            Cell: function CelluleActif({ value }: CellProps<ModeleHoraire>) {
                return value ? <Badge variant="light">Actif</Badge> : <Badge variant="secondary">Inactif</Badge>;
            },
            filter: 'equals',
        },
        {
            Header: "# modèle d'horaire",
            accessor: 'id',
            sortType: (rowA, rowB) => {
                return rowA.original.name.localeCompare(rowB.original.name, 'fr-CA');
            },
        },
        {
            Header: 'Nom',
            accessor: 'name',
            sortType: (rowA, rowB) => {
                return rowA.original.name.localeCompare(rowB.original.name, 'fr-CA');
            },
        },
        {
            Header: '# Activités',
            Cell: function CelluleContacts({ row }: CellProps<ModeleHoraire>) {
                const title2 = "Liste des activités du modèle d'horaire " + row.original.name;
                const length = row.original.modeleHoraireActivite.length;
                return row.original.modeleHoraireActivite ? (
                    <>
                        <PopoverSimple
                            inList
                            placement="bottom"
                            texte={
                                <>
                                    <DynamicTableActivite title={title2} data={row.original.modeleHoraireActivite} />
                                </>
                            }
                        >
                            <u>{length as any}</u>
                        </PopoverSimple>
                    </>
                ) : null;
            },
        },
        {
            Header: '# Produits',
            Cell: function CelluleContacts({ row }: CellProps<ModeleHoraire>) {
                const title2 = "Liste des produits du modèle d'horaire " + row.original.name;
                const length = row.original.modeleHoraireProduit.length;
                return row.original.modeleHoraireProduit ? (
                    <>
                        <PopoverSimple
                            inList
                            placement="bottom"
                            texte={
                                <>
                                    <DynamicTableProduit title={title2} data={row.original.modeleHoraireProduit} />
                                </>
                            }
                        >
                            <u>{length as any}</u>
                        </PopoverSimple>
                    </>
                ) : null;
            },
        },
    ];

    const deleteModeleHoraire = async (p: ModeleHoraire) => {
        if (window.confirm("Etes-vous sur de vouloir supprimer ce modèle d'horaire?")) {
            try {
                await updateModeleHoraireQuery({ id: p.id, actif: !p.actif });
            } catch (error) {
                const { response, message } = error as any;
                if (response?.status === 409) {
                    bsAlert("D'autres entités dépendent de ce modèle d'horaire, impossible de le supprimer", 'warning');
                } else {
                    bsAlert(`Erreur dans la suppression du fournisseur: ${message}`, 'danger');
                }
            }
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <EnteteDePage texte="Modèles d'horaire" cacherBoutonRetour />
                </Col>
                <Col xs="auto">
                    <ButtonGroup>
                        <LinkContainer to="new">
                            <Button size="sm" variant="outline-primary" className="d-flex align-items-center">
                                <BiPlus /> Ajouter un modèle d'horaire
                            </Button>
                        </LinkContainer>
                    </ButtonGroup>
                </Col>
            </Row>
            <TableSimple
                colonnes={colonnes}
                resultat={listModelesHoraire}
                lien="id"
                hover
                affichageMenu={(modeleHoraire: ModeleHoraire) => (
                    <>
                        <Dropdown.Item onClick={() => navigate(String(modeleHoraire.id))}>Modifier</Dropdown.Item>
                        <Dropdown.Item className="text-danger" onClick={() => deleteModeleHoraire(modeleHoraire)}>
                            Supprimer
                        </Dropdown.Item>
                    </>
                )}
                affichageFiltres={FiltreActif}
                etatInitial={{
                    filters: [
                        {
                            id: 'actif',
                            value: true,
                        },
                    ],
                    sortBy: [
                        {
                            id: 'name',
                        },
                    ],
                    hiddenColumns: ['actif'],
                }}
            />
        </>
    );
}
